// START Open Requre.JS wrapper
define([
	'jquery'
	], function($) {
// END Open Require.JS wrapper


/****
 * Image with overlay displays an image with text or cta button overlay
 ***/

	var PLUGIN_IDENTIFIER = "imageWithOverlayDatalayer";
	var imageWithOverlayDatalayer = function( element, options ) {
		this.element = element;
		this.options = options;

		// This next line takes advantage of HTML5 data attributes
		// to support customization of the plugin on a per-element
		// basis. For example,
		// <section class='image_with_overlay2' data-imagewithoverlaydatalayer-options='{"message":"Goodbye World!"}'></section>
		this.metadata = $(this.element).data('imagewithoverlaydatalayer-options');
	};

	imageWithOverlayDatalayer.prototype = {
		defaults: {
			impressionEvent: "promotionImpression",
			interactionEvent: "promotionInteraction"
		},

		init : function () {
			console.log("Initializing Image with Overlay for", $(this.element));

			var self = this;

			self.config = $.extend( {}, self.defaults, self.options, self.metadata );

			// Initialize events
			self.events();

			return self;
		},

		events : function () {
			var self = this;

			// check if data exisits
			if(self.config.promoId || self.config.promoName) {

				// Populate Data Layer with analytics info and event on page load of promotion
				self.populateDataLayer(self.config.impressionEvent);

				// Populate Data Layer with analytics info on interaction with promotion
				$(self.element).on('click', function() {
					self.populateDataLayer(self.config.interactionEvent);
				});

			}
		},

		createProductObject: function() {
			var self = this,
			productObject = {};

			if(self.config.promoId) {
				productObject.id = self.config.promoId;
			}

			if(self.config.promoName) {
				productObject.name = self.config.promoName;
			}

			if(self.config.promoCreative) {
				productObject.creative = self.config.promoCreative;
			}

			if(self.config.promoPosition) {
				productObject.position = self.config.promoPosition;
			}

			return productObject;
		},

		populateDataLayer : function (eventData) {
			var self = this,
				event = eventData,
				productObject = self.createProductObject();

			if (event === self.config.impressionEvent) { // impression
				dataLayer.push({
					'event': event,
					'ecommerce': {
						'promoView': productObject
					}
				});
			} else { // interaction
				dataLayer.push({
					'event': event,
					'ecommerce': {
						'promoClick': productObject
					}
				});
			}
		},
	};

	imageWithOverlayDatalayer.defaults = imageWithOverlayDatalayer.prototype.defaults;

	// prevent duplicate instantiation
	$.fn.imageWithOverlayDatalayer = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new imageWithOverlayDatalayer(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};


// START close Require.JS wrapper
	}
);
// END close Require.JS wrapper